<i
  class="fa fa-info-circle fa-sm ml-1 text-secondary"
  tooltip
  [tooltipTitle]="title"
  [placement]="placement"
  [delay]="delay"
  aria-hidden="true"
></i>
